<template>
  <div class="text-body-2 text-md-body-1" :class="{ 'text-md-center': center }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SecondText",
  props: {
    center: Boolean
  }
};
</script>
